import React from "react";
import Project from "../components/Project";
import Title from "../components/Title";
import { useScroll } from "../components/useScroll";
import { motion } from "framer-motion";
import GuruPharma from "../assets/proj-gurupharma.jpg";
import Aangan from "../assets/proj-aangan.jpg";
import Dishita from "../assets/proj-dishita.jpg";
import Mahadev from "../assets/proj-mahadev.jpg";
import GreyMatter from "../assets/proj-greymatter.jpg";
import "../styles/sections/Portfolio.scss";
import { textAnimation, cardAnimation } from "../utils/Animations";

const projects = [
  {
    image: GuruPharma,
    client: "Guru Pharma Machinery · Ahmedabad",
    title: "Pharmaceutical Machinery Manufacturer Website",
    tags: ["Astro", "No JavaScript", "Spec Tables", "7 Pages"],
    // Every other card carries a client quote. This one describes the work
    // instead: GPM commissioned a sample to review and has not signed off, so
    // there is no testimonial to print and inventing one would put words in a
    // real company's mouth. Swap this line for their words if they give any.
    subTitle:
      "A manufacturer's catalogue for two flagship process plants — the machine and its full specification table lead every page, with enquiry forms throughout. Fully static, no client-side JavaScript at all.",
    liveUrl: "https://gurupharmamachinery.netlify.app/",
  },
  {
    image: Aangan,
    client: "Aangan Interiors · Ahmedabad",
    title: "Interior Design Studio Website",
    tags: ["React", "Responsive", "SEO", "WhatsApp"],
    subTitle:
      '"A beautiful, fast site that finally shows our work the way it deserves — enquiries went up within weeks." — Rahul Mehta, Founder',
    liveUrl: "https://aanganinterior.netlify.app/",
  },
  {
    image: Dishita,
    client: "Dishita Ornaments · Manek Chowk",
    title: "Jewellery Store Website",
    tags: ["React", "Luxury UI", "Catalogue", "Google Maps"],
    subTitle:
      '"Customers finally find us online, and the design matches the quality of our jewellery." — Meera Patel, Owner',
    liveUrl: "https://dishitaornaments.netlify.app/",
  },
  {
    image: Mahadev,
    client: "Mahadev Transport · Aslali",
    title: "Logistics & Warehousing Website",
    tags: ["Astro", "Fast", "Lead Capture", "Multi-page"],
    subTitle:
      '"A professional website that brings us serious B2B and export enquiries." — Suresh Patel, Director',
    liveUrl: "https://mahadev-transport.netlify.app/",
  },
  {
    image: GreyMatter,
    client: "GreyMatter · Grey Agency",
    title: "Podcast Platform Rebuild",
    tags: ["React", "Editorial", "Animation", "Media"],
    subTitle:
      '"A bold, editorial rebuild of our podcast experience — exactly the modern feel we wanted." — Creative Lead, Grey',
    liveUrl: "https://grey-rebuild.netlify.app/podcasts",
  },
];

function Portfolio() {
  // Low threshold so the reveal triggers on mobile/tablet too, where the
  // stacked cards make the section taller than the viewport (40% can never
  // be visible at once, which left the cards stuck at opacity/scale 0).
  const [element, controls] = useScroll(0.05);

  return (
    <div className="portfolio-container" id="portfolio" ref={element}>
      <div className="container">
        <motion.div
          className="title-container"
          variants={textAnimation}
          animate={controls}
          transition={{ duration: 1 }}
        >
          <Title title="Our Portfolio" color="blue" lineCenter={true} />
          <p>Recent websites we have designed, built and shipped for our clients.</p>
        </motion.div>
        <div className="projects">
          {projects.map((project, index) => (
            <Project
              key={index}
              image={project.image}
              client={project.client}
              title={project.title}
              tags={project.tags}
              subTitle={project.subTitle}
              liveUrl={project.liveUrl}
              variants={cardAnimation}
              animate={controls}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Portfolio;
